import { useCallback } from 'react';
import { useI18nStore } from '../store/i18n.js';

function getByPath(obj, path) {
  if (!path) return undefined;
  return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
}

export function useT() {
  const messages = useI18nStore((s) => s.messages);

  return useCallback((key, fallback, vars) => {
    const value = getByPath(messages, key);
    const text = typeof value === 'string' ? value : (fallback || key);
    if (!vars || typeof text !== 'string') return text;
    return text.replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, (_, name) => {
      const replacement = vars[name];
      return replacement === undefined || replacement === null ? '' : String(replacement);
    });
  }, [messages]);
}
